import {dom as $7230ffa83bc0c2cf$export$df3a06d6289f983e, useContextProps as $7230ffa83bc0c2cf$export$29f1550f4b0d4415} from "./utils.mjs";
import $91cTq$react, {createContext as $91cTq$createContext, forwardRef as $91cTq$forwardRef} from "react";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

const $650bea62ab5f5f0f$export$744d98a3b8a94e1c = /*#__PURE__*/ (0, $91cTq$createContext)({});
const $650bea62ab5f5f0f$export$16e4d70cc375e707 = /*#__PURE__*/ (0, $91cTq$forwardRef)(function Keyboard(props, ref) {
    [props, ref] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, ref, $650bea62ab5f5f0f$export$744d98a3b8a94e1c);
    return /*#__PURE__*/ (0, $91cTq$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).kbd, {
        dir: "ltr",
        ...props,
        ref: ref
    });
});


export {$650bea62ab5f5f0f$export$744d98a3b8a94e1c as KeyboardContext, $650bea62ab5f5f0f$export$16e4d70cc375e707 as Keyboard};
//# sourceMappingURL=Keyboard.mjs.map
